'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _Container = require('./components/Container.Timeline');

var _Container2 = _interopRequireDefault(_Container);

var _Arrow = require('./components/Arrow.Timeline');

var _Arrow2 = _interopRequireDefault(_Arrow);

var _OutlineContent = require('./components/OutlineContent.Timeline');

var _OutlineContent2 = _interopRequireDefault(_OutlineContent);

var _Content = require('./components/Content.Timeline');

var _Content2 = _interopRequireDefault(_Content);

var _Gradient = require('./components/Gradient.Timeline');

var _Gradient2 = _interopRequireDefault(_Gradient);

var _Entry = require('./components/Entry.Timeline');

var _Entry2 = _interopRequireDefault(_Entry);

var _NoEntry = require('./components/NoEntry.Timeline');

var _NoEntry2 = _interopRequireDefault(_NoEntry);

var _Loader = require('./components/Loader.Timeline');

var _Loader2 = _interopRequireDefault(_Loader);

var _More = require('./components/More.Timeline');

var _More2 = _interopRequireDefault(_More);

var _Line = require('./components/Line.Timeline');

var _Line2 = _interopRequireDefault(_Line);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components


var Timeline = function (_Component) {
  _inherits(Timeline, _Component);

  function Timeline() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Timeline);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Timeline.__proto__ || Object.getPrototypeOf(Timeline)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      disabledLeft: true,
      disabledRight: false
    }, _this.dom = null, _this.animation = null, _this.isAnimating = false, _this.animationDuration = 300, _this.onRef = function (dom) {
      if (_this.dom) {
        (0, _jquery2.default)(_this.dom).off('scroll', _this.checkDisabled);
      }

      if (!dom) return;
      _this.dom = dom;
      (0, _jquery2.default)(dom).on('scroll', _this.checkDisabled);
    }, _this.checkDisabled = function () {
      var _this$dom = _this.dom,
          scrollLeft = _this$dom.scrollLeft,
          offsetWidth = _this$dom.offsetWidth,
          scrollWidth = _this$dom.scrollWidth;
      var combinedWidth = scrollLeft + offsetWidth;
      var disabledLeft = scrollLeft <= 0;
      var disabledRight = combinedWidth >= scrollWidth;
      if (disabledLeft !== _this.state.disabledLeft || disabledRight !== _this.state.disabledRight) _this.setState({
        disabledLeft: disabledLeft,
        disabledRight: disabledRight
      });
    }, _this.autoScroll = function (position) {
      if (!_this.dom) return;
      var scrollLeft = _this.dom.scrollLeft + (position === 'left' ? -150 : 150);
      (0, _jquery2.default)(_this.dom).animate({
        scrollLeft: scrollLeft
      }, _this.animationDuration);
    }, _this.startAnimating = function (position) {
      if (!_this.dom) return;

      _this.animateScroll(position);

      _this.animation = setInterval(function (e) {
        return _this.animateScroll(position);
      }, _this.animationDuration);
    }, _this.animateScroll = function (position) {
      if (_this.isAnimating) return;
      _this.isAnimating = true;
      var scrollLeft = _this.dom.scrollLeft + (position === 'left' ? -150 : 150);
      setTimeout(function () {
        _this.isAnimating = false;
      }, _this.animationDuration - 2);
      (0, _jquery2.default)(_this.dom).animate({
        scrollLeft: scrollLeft
      }, {
        duration: _this.animationDuration,
        easing: 'linear'
      });
    }, _this.stopAnimating = function () {
      if (!_this.animation) return;
      clearInterval(_this.animation);
      _this.animation = null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Timeline, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.disabledLeft && this.state.disabledLeft || !prevState.disabledRight && this.state.disabledRight) this.stopAnimating();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          disabledLeft = _state.disabledLeft,
          disabledRight = _state.disabledRight;
      var _props = this.props,
          loading = _props.loading,
          children = _props.children,
          onMore = _props.onMore,
          reverse = _props.reverse;
      var entries = children(_Entry2.default);
      return _react2.default.createElement(_Container2.default, null, _react2.default.createElement(_Arrow2.default, {
        position: 'left',
        startScrolling: this.startAnimating,
        endScrolling: this.stopAnimating,
        disabled: disabledLeft || !entries.length
      }), loading && !entries.length ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(_OutlineContent2.default, null, _react2.default.createElement(_Line2.default, null), _react2.default.createElement(_Content2.default, {
        innerRef: this.onRef
      }, onMore !== null && reverse && _react2.default.createElement(_More2.default, {
        loading: loading,
        onClick: onMore,
        reverse: true
      }), !!entries.length ? entries : _react2.default.createElement(_NoEntry2.default, null, 'No Data'), onMore !== null && !reverse && _react2.default.createElement(_More2.default, {
        loading: loading,
        onClick: onMore
      }))), _react2.default.createElement(_Arrow2.default, {
        position: 'right',
        startScrolling: this.startAnimating,
        endScrolling: this.stopAnimating,
        disabled: disabledRight || !entries.length
      }), _react2.default.createElement(_Gradient2.default, {
        left: true
      }), _react2.default.createElement(_Gradient2.default, null));
    }
  }]);

  return Timeline;
}(_react.Component);

Timeline.propTypes = {
  children: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  onMore: _propTypes2.default.func,
  reverse: _propTypes2.default.bool
};
Timeline.defaultProps = {
  children: function children() {
    return [];
  },
  loading: false,
  onMore: null,
  reverse: false
};
exports.default = Timeline;